/**
 * SINGLE SOURCE OF TRUTH (frontend) de los campos válidos para `mergeWithCatalog`.
 *
 * Estos son los campos del JOIN catalog que una columna Core/Native puede declarar
 * en `mergeWithCatalog` para renderizar via MergedTomaCatalogCell. El dropdown de
 * ColumnConfigSection y el validador de celda consumen esta lista.
 *
 * PARIDAD OBLIGATORIA con el backend `server/utils/mergeCatalogFields.js`
 * (mirroreado a functions/ por sync-backend.sh). El drift front↔back entre estas
 * dos listas fue la causa raíz de PT-#81 (el save de `seller` daba 400 en prod).
 * El test `tests/unit/mergeCatalogFieldsParity.test.js` FALLA si divergen.
 *
 * Al agregar/quitar un campo: editar ESTA lista Y su gemela backend en el mismo commit.
 */
export const MERGE_CATALOG_FIELDS = [
  'catalog_brand',
  'catalog_category',
  'subcategory',
  'segmento',
  'contenido',
  'udm',
  'sku_origen',
  'sku_unificado',
  'seller',
] as const;

export type CatalogField = typeof MERGE_CATALOG_FIELDS[number];
